import React, { useEffect } from "react";
import ReactStars from "react-rating-stars-component";

import {
  ReviewHalfStarIcon,
  ReviewEmptyStarIcon,
  ReviewFilledStarIcon,
} from "../../../assets/images/icon/iconsProvider";

const ReviewStars = ({
  isEdit = false,
  isHalf = true,
  value = 0,
  size = 10,
  spacing = "20px",
}) => {

  return (
    <ReactStars
      key={value}
      size={size}
      edit={isEdit}
      isHalf={isHalf}
      value={value}
      emptyIcon={<ReviewEmptyStarIcon className={"review-icons"} />}
      halfIcon={<ReviewHalfStarIcon className={"review-icons-half"} />}
      filledIcon={<ReviewFilledStarIcon className={"review-icons"} />}
      starSpacing={spacing}
      classNames={"d-flex gap-2"}
    />
  );
};

export default ReviewStars;
